// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"360":"9c3a24d5","794":"d090efa3"}[chunkId] + ".css";
};